export enum Partner {
	UNICARE = '8',
	KDAR = '23',
}
